// extracted by mini-css-extract-plugin
export var productImage = "_q1-1";
export var viewLink = "_q1-2";
export var wishlistItem = "_q1-0";